import './App.css';
import { useContext } from 'react';
import { GTIThemeProvider } from "@gti-controls-v2/web-core";
import { AuthProvider } from './providers/auth';
import { LocaleContext, LocaleProvider } from './providers/locale';
import customTheme from "./theme";
import AppRouter from './router';
import CookiesConsent from './containers/Cookies-consent/Cookies-consent';

function ThemeWrapper(props) {
  const localeContext = useContext(LocaleContext);

  return (
    <GTIThemeProvider
      theme={customTheme}
      locale={localeContext.locale}
    >
      {props.children}
    </GTIThemeProvider>
  );
}

/** App */
function App() {
  return (
    <LocaleProvider>
      <ThemeWrapper>
        <AuthProvider>
            <AppRouter />
            <CookiesConsent />
        </AuthProvider>
      </ThemeWrapper>
    </LocaleProvider>
  );
}

export default App;
